import React from 'react';
import { Heading } from '../../components';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const { text, heading, showAsIngress = false, isRich = false } = props;
  const textClass = showAsIngress ? css.ingress : css.text;
  const content = richText(text, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });


  return text ? (
    <section className={css.sectionText}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          {heading}
        </Heading>
      ) : null}
      <p 
        className={textClass} 
        dangerouslySetInnerHTML={
          {__html: isRich ? text.replace(/＜/g, '<').replace(/＞/g, '>').replace(/\u200B/g, '').replace(/^<p>(.*?)<\/p>$/s, '$1') : content}
          }
      />
    </section>
  ) : null;
};

export default SectionTextMaybe;
